module.exports = __webpack_public_path__ + "img/834000336_4.e0604ab9.jpg";